import { Policy } from 'features/signUp/types';

export interface SettingsResponse {
  settings: {
    passive_tracking_enabled?: boolean;
    eula_policy: Policy;
    privacy_policy: Policy;
  };
}

export enum ConfirmationDialogState {
  CONFIRM = 'CONFIRM',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

export interface NotificationSettingsData {
  enabledInExternalSystem: boolean;
  userPhoneNumber: string;
  enabled: boolean;
  hospitalTwilioSmsNumber?: string;
}

export type ConsentModuleType = 'logging' | 'data_reporting' | 'email_contact';

export interface ConsentModule {
  id: number;
  link_url: string;
  link_text: string | null;
  headline: string;
  short_headline: string | null; // Unused for now on web
  body: string | null;
  type: ConsentModuleType;
}

export interface ConsentSignature {
  module_id: number;
  answered_date: number | null; // Unix timestamp
  consented: boolean;
}

/**
 * Represents a signed consent module, combining the module details with the user's signature.
 * The `module_id` field is omitted to avoid redundancy with `ConsentModule.id`.
 */
export type SignedConsentModule = ConsentModule & Omit<ConsentSignature, 'module_id'>;

export interface SettingsModalContentProps {
  sectionId: SettingsSectionId;
  enabledInExternalSystem?: boolean;
  enabled?: boolean;
  userPhoneNumber?: string;
  hospitalTwilioSmsNumber?: string;
  onChangeNotificationPreferences?: () => void;
  handleModalOpen?: (sectionId: string) => void;
  handleModalClose?: () => void;
  isModalOpen?: boolean;
  modalProps?: any;
  setModalProps?: React.Dispatch<React.SetStateAction<any>>;
  settingModalSection?: React.ReactNode;
  setSettingsModalSection?: React.Dispatch<React.SetStateAction<React.ReactNode>>;
  onModalOpen?: (sectionId: string) => void;
  onModalClose?: () => void;
  stepCountTaskEnabled?: boolean;
}

export const SETTINGS_SECTION_IDS = {
  ACCOUNT: 'account',
  NOTIFICATIONS: 'notifications',
  STEPS: 'steps',
  SECURITY: 'security',
  SUPPORT: 'support',
  TERMS: 'terms',
} as const;

export type SettingsSectionId = (typeof SETTINGS_SECTION_IDS)[keyof typeof SETTINGS_SECTION_IDS];

export interface SettingsSection {
  id: SettingsSectionId;
  label: string;
  isEnabled?: boolean;
  labelTranslationKey?: string;
  sectionHeading: string;
  modalTitleKey: string;
  modalTitleId: string;
}

export interface MostRecentPoliciesResponse {
  eula_policy: Policy;
  privacy_policy: Policy;
}
